<template >
  <section class="bg-white py-4 px-4 rounded-2xl flex justify-center">
        <Splide :options="{type: 'loop', autoplay: true, interval: 5000, pauseOnHover: true}" aria-label="My Favorite Images">
            <SplideSlide v-for="banner in banners" :key="banner">
                <a :href="banner.link" :target="banner.linkTarget">
                    <img class="rounded-2xl" :src="banner.mediaUrl" :alt="banner.altText">
                </a>
            </SplideSlide>
        </Splide>
  </section>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";
import '@splidejs/vue-splide/css';
import { Splide, SplideSlide } from '@splidejs/vue-splide';

export default {
    components: {
        Icon,
        Splide,
        SplideSlide,
    },
    props: {
        banners: Array,
    },
    computed: {
        slidesLenght() {
            return (this.banners?.length * 30) + 'px';
        }
    }
};
</script>
<style>
    .splide__arrow {
        background-color: white;
        border: 1px solid #0771c5;
        color: #0771c5;
        opacity: 100%;
    }

    .splide__arrow:hover {
        background-color: #0771c5;
        border-color: white;
        color: white;
    }

    .splide__arrow--prev{
        left: 6px;
    }

    .splide__arrow--next{
        right: 6px;
    }

    .splide__arrow svg{
        fill: currentColor;
    }

    .splide__pagination {
        background: white;
        bottom: 0px;
        max-width: v-bind(slidesLenght);
        margin-left: auto;
        margin-right: auto;
        transform: translateY(-50%);
        left: 0;
        right: 0;
        border-radius: 30px;
    }

    .splide__pagination li {
        display: flex;
    }

    .splide__pagination__page.is-active {
        background-color: #081D38;
        transform: none;
    }

    .splide__pagination__page {
        transform: none;
        background: #9ca3af;
    }
</style>
